export default __webpack_public_path__ + "static/media/payroll-feature-time.fe056f7c.svg";